import { Box, Link } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import api from '../../Auth/api'

const INITIAL_BILLING_TYPE_ID = 50
const ADDITIONAL_BILLING_TYPE_ID = 90

/**
 * Ссылка на скан счёта.
 *
 * Для стадий "Счёт" (50) и "Доп.счёт" (90) файл берётся из 1С
 * через GET /paid-service/task-get-bill-file?taskId={taskId}.
 * Для остальных случаев используется GET /multimedia/{fileId}.
 *
 * Файл скачивается через axios (с авторизационными заголовками)
 * и отдаётся пользователю через временный object URL.
 */
export default function BillScanLink({
  fileId,
  taskId,
  taskTypeId,
  billNumber,
  billDate,
  label
}) {
  const [loading, setLoading] = React.useState(false)

  const formattedDate = billDate
    ? dayjs(billDate).format('DD.MM.YYYY')
    : null

  const shouldUseBillFileEndpoint =
    taskId &&
    (taskTypeId === INITIAL_BILLING_TYPE_ID ||
      taskTypeId === ADDITIONAL_BILLING_TYPE_ID)

  if (!fileId && !shouldUseBillFileEndpoint) return null

  const handleClick = async (event) => {
    event.preventDefault()
    if (loading) return

    setLoading(true)

    try {
      const url = shouldUseBillFileEndpoint
        ? `paid-service/task-get-bill-file?taskId=${taskId}`
        : `multimedia/${fileId}`

      const response = await api.get(url, {
        responseType: 'blob'
      })

      // Для счетов из 1С бэкенд всегда отдаёт PDF
      const blobType = shouldUseBillFileEndpoint
        ? 'application/pdf'
        : response.headers['content-type'] || 'application/pdf'

      const blob = new Blob([response.data], { type: blobType })
      const objectUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = objectUrl
      link.download = `${label} №${billNumber || '—'}${formattedDate ? ` от ${formattedDate}` : ''}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()

      setTimeout(() => {
        window.URL.revokeObjectURL(objectUrl)
      }, 10000)
    } catch (error) {
      console.error('Ошибка при скачивании скана счёта:', error)
      alert('Не удалось скачать скан счёта')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box sx={{ display: 'inline-block' }}>
      <Link
        href="#"
        onClick={handleClick}
        underline="hover"
        sx={{ opacity: loading ? 0.6 : 1 }}
      >
        {label} №{billNumber || '—'}
        {formattedDate ? ` от ${formattedDate}` : ''}.pdf
        {loading ? ' (загрузка...)' : ''}
      </Link>
    </Box>
  )
}
